module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-3",
      "xml:lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/HueTitle1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("A Turning Point of "), _c('br'), _vm._v("the American War in Vietnam")])]), _vm._v(" "), _c('h2', {
    staticClass: "AU_Author_names ParaOverride-4",
    attrs: {
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Mark "), _c('br'), _vm._v("Bowden")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-5"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "src": "image/V-1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-3"
  }, [_vm._v("Grove Press")]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("New York")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-184c9708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_V45572.vue
// module id = 69
// module chunks = 0